import { createComponent } from "@helpers/admin";
import component from "@template/blocks/domain/DomainNameSearchTabs";
import { TField } from "@/lib/types/puck";

const searchFields: TField = {
  label: "",
  type: "object",
  objectFields: {
    input: {
      label: "Input",
      type: "input",
    },
    submit: {
      label: "Button",
      type: "button",
    },
    label: {
      label: "Label",
      type: "object",
      objectFields: {
        value: {
          label: "Label",
          type: "text",
        },
        icon: {
          label: "Icon",
          type: "icon",
        },
      },
    },
    href: {
      label: "HREF",
      type: "text",
    },
  },
};

export const DomainNameSearchTabs = createComponent({
  label: "Search Tabs",
  component,
  fields: {
    search: {
      label: "Search",
      type: "object",
      objectFields: {
        input: {
          label: "Input",
          type: "input",
        },
        submit: {
          label: "Button",
          type: "button",
        },
        label: {
          label: "Label",
          type: "object",
          objectFields: {
            value: {
              label: "Label",
              type: "text",
            },
            icon: {
              label: "Icon",
              type: "icon",
            },
          },
        },
        href: {
          label: "HREF",
          type: "text",
        },
      },
    },
    searchBulk: {
      label: "Bulk Search",
      type: "object",
      objectFields: {
        input: {
          label: "Input",
          type: "input",
        },
        fileInput: {
          label: "File Input",
          type: "input",
        },
        submit: {
          label: "Button",
          type: "button",
        },
        label: {
          label: "Label",
          type: "object",
          objectFields: {
            value: {
              label: "Label",
              type: "text",
            },
            icon: {
              label: "Icon",
              type: "icon",
            },
          },
        },
        href: {
          label: "HREF",
          type: "text",
        },
      },
    },
    defaultSelected: {
      label: "Selected",
      type: "select",
      options: [
        { label: "Search", value: "search" },
        { label: "Bulk", value: "bulk" },
      ],
    },
    altStyling: {
      label: "Alternate Styling",
      type: "boolean",
    },
  },
});
